import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


@Pipe({name: 'safeHTML'})
export class SafeHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(html: string, bypassSecurity: boolean = true): SafeHtml {
    if (bypassSecurity) {
      return this.sanitizer.bypassSecurityTrustHtml(html);
    } else {
      return html;
    }
  }
}
